import { defineComponent as _defineComponent } from 'vue'
import { NewBuyBoxView } from '@/stores/user.store';
import { useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { computed } from 'vue';
import { useBuyboxLoggedInExp } from '@/components/experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';
import { useSingleQtvExp } from '@/components/experiments/SingleQtvExp/composables/useSingleQtvExp';
import { useTitlePageLoggedInExp } from '@/components/experiments/TitlepageLoggedInExp/composables/useTitlepageLoggedInExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxTypeSwitcher',
  props: {
    additionalContexts: null,
    buyBoxType: null
  },
  emits: ["buyBoxTypeSwitched"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'buyBoxTypeSwitched', payload: { buyBoxType: NewBuyBoxView }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	additionalContexts: SnowplowContext[];
	buyBoxType?: NewBuyBoxView;
};





const {
	newBuyboxTooltipAcknowledged,
	setNewBuyboxTooltipAcknowledged,
	newBuyboxView,
	setNewBuyboxView,
	isUserFirstVisit,
	isLoggedIn,
	loggedInExpBuyboxView,
} = useUserStore();

const { t } = useI18n();
const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();
//SINGLE_QTV_EXP
const { trackSingleQtvExp } = useSingleQtvExp();
//SINGLE_QTV_EXP

const { titlePageActiveVariant } = useTitlePageLoggedInExp();

const buyboxView = computed(() => {
	if (!!props.buyBoxType) {
		return props.buyBoxType;
	}

	if (!!titlePageActiveVariant.value && titlePageActiveVariant.value !== 'control') {
		return loggedInExpBuyboxView.value;
	}

	return newBuyboxView.value;
});

const showTooltip = computed(() => {
	if (isLoggedIn.value) {
		return !newBuyboxTooltipAcknowledged.value;
	}
	return !newBuyboxTooltipAcknowledged.value && isUserFirstVisit.value === false;
});

const handleListClicked = () => {
	trackSingleQtvExp({
		action: 'click',
		label: `buybox_view_clicked_${NewBuyBoxView.LIST}`,
	});
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.LIST });
	} else {
		setNewBuyboxView(NewBuyBoxView.LIST);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.LIST);
};

const handleGridClicked = () => {
	trackSingleQtvExp({
		action: 'click',
		label: `buybox_view_clicked_${NewBuyBoxView.GRID}`,
	});
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.GRID });
	} else {
		setNewBuyboxView(NewBuyBoxView.GRID);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.GRID);
};

const trackToggleEvent = (label: NewBuyBoxView) => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_view_clicked', label }, props.additionalContexts);
	trackBuyboxLoggedInExp({
		action: 'click',
		label: `buybox_view_clicked_${label}`,
	});
};

const close = () => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_switch_acknowledged' }, props.additionalContexts);
	setNewBuyboxTooltipAcknowledged();
};

return { __sfc: true,props, emit, newBuyboxTooltipAcknowledged, setNewBuyboxTooltipAcknowledged, newBuyboxView, setNewBuyboxView, isUserFirstVisit, isLoggedIn, loggedInExpBuyboxView, t, trackBuyboxLoggedInExp, trackSingleQtvExp, titlePageActiveVariant, buyboxView, showTooltip, handleListClicked, handleGridClicked, trackToggleEvent, close }
}

})